module.exports = __webpack_public_path__ + "img/form-warning.ecb83a94.svg";